module.exports = __webpack_public_path__ + "static/media/1. Bruma, Mixta sobre lámina cobre y madera, 50 x 70 cm, 2011 copy.34e1fb37.png";